/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useState } from 'react';
import { Button, Grid } from '@material-ui/core';
import CommonButton from 'app/common/Component/Button/CommonButton';
import Popup from 'app/common/Component/Popup/Popup';
import TableComponent from 'app/common/Component/Table/TableComponent';
import { Form, Formik, useFormikContext } from 'formik';
import { useStore } from "app/stores";
import SaveIcon from '@material-ui/icons/Save';
import BlockIcon from '@material-ui/icons/Block';
import { useTranslation } from "react-i18next";
import { observer } from 'mobx-react';
import { formatMoney, getDateTime } from 'app/common/LocalFunction';
import { LEAD_SOURCE_LEVEL, VOUCHER_INVOICE_TYPE } from 'app/common/LocalConst';
import GlobitsMultiDatePicker from 'app/common/form/GlobitsMultiDatePicker';
import { Search } from '@material-ui/icons';
import { getListCode } from "app/services/CustomerSourceService";

function VoucherDepositDeductionPopup({
    open,
    handleClose
}) {
    const { t } = useTranslation();
    const { setFieldValue, values } = useFormikContext();
    const [selectedRows, setSelectedRows] = useState([]);
    const {
        dataVoucherFee,
        searchVoucherFee,
        handleChangeFormSearch,
        resetStorePopup
    } = useStore().patientManagementStore.voucherDepositDeductionStore;

    const urlParams = new URLSearchParams(window.location.search);
    const patientIdUrl = urlParams.get("patientId");

    const resolveVoucherSearchContext = (values) => {
        const departmentId =
            values?.newTreatmentPlanCard?.department?.id ||
            values?.newPatientServiceRegister?.department?.id ||
            values?.newProduct?.department?.id
            || values?.department?.id

        return {
            listDepId: departmentId ? [departmentId] : [],
            excludeTreatmentPlanCardId:
                values?.oldTreatmentPlanCard?.id ||
                values?.id ||
                null,

            excludePatientServiceRegisterId:
                values?.oldPatientServiceRegister?.id ||
                values?.id ||
                null,

            excludeDrugOrderId:
                values?.oldProduct?.id ||
                values?.id ||
                null,
        };
    };

    useEffect(() => {
        if (!patientIdUrl) return;

        const {
            listDepId,
            excludeTreatmentPlanCardId,
            excludePatientServiceRegisterId,
            excludeDrugOrderId,
        } = resolveVoucherSearchContext(values);

        const payload = {
            patientId: patientIdUrl,
            listDepId,
            excludeTreatmentPlanCardId,
            excludePatientServiceRegisterId,
            excludeDrugOrderId,
        };

        handleChangeFormSearch(payload);
    }, [patientIdUrl, values]);

    const selectedVoucherIds = React.useMemo(() => {
        return (
            values?.voucherAllocations?.map(item => item.voucher?.id) || []
        );
    }, [values?.voucherAllocations]);

    const initSelectedRows = React.useMemo(() => {
        if (!dataVoucherFee?.content?.length) return [];

        return dataVoucherFee.content.filter(row =>
            selectedVoucherIds.includes(row.id)
        );
    }, [dataVoucherFee?.content, selectedVoucherIds]);

    const handleGetListCodeSource = async (obj, setFieldValue) => {
        try {
            const { data } = await getListCode(obj);
            setFieldValue("listCodeSource", data || []);
        } catch (error) {
            //console.error(error);
        }
    }
    const handleClosePopup = () => {
        handleClose();
        resetStorePopup()
    }

    return (
        <Popup
            open={open}
            handleClose={handleClosePopup}
            title={"Danh sách trừ tiền cọc"}
            height={"360px"}
            action={
                <>
                    <CommonButton
                        className="mr-2"
                        onClick={() => {
                            const current = values?.voucherAllocations || [];
                            const newItems = selectedRows.map((row) => ({
                                voucher: row,
                            }));

                            const voucherAllocationsData = [...current, ...newItems];

                            setFieldValue("voucherAllocations", voucherAllocationsData);

                            // patient ko đổi nên lấy từ old được
                            const patientId =
                                values?.patient?.id ||
                                values?.oldTreatmentPlanCard?.patient?.id ||
                                values?.oldPatientServiceRegister?.patient?.id ||
                                values?.oldProduct?.patient?.id;

                            // thông tin khác thì phải lấy từ form hiện tại
                            const invoiceItemAllocations =
                                values?.invoiceItemAllocations ||
                                values?.newTreatmentPlanCard?.invoiceItemAllocations ||
                                values?.newPatientServiceRegister?.invoiceItemAllocations ||
                                values?.newProduct?.invoiceItemAllocations || [];
                            const startDate =
                                values?.startDate ||
                                values?.orderDate ||
                                values?.newTreatmentPlanCard?.startDate ||
                                values?.newTreatmentPlanCard?.orderDate ||
                                values?.newPatientServiceRegister?.startDate ||
                                values?.newPatientServiceRegister?.orderDate ||
                                values?.newProduct?.startDate ||
                                values?.newProduct?.orderDate;
                            const departmentId =
                                values?.department?.id ||
                                values?.newTreatmentPlanCard?.department?.id ||
                                values?.newPatientServiceRegister?.department?.id ||
                                values?.newProduct?.department?.id;

                            const searchCodeSource = {
                                level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                                startDate: startDate,
                                patientId: patientId || patientIdUrl,
                                departmentId: departmentId,

                                voucherIds: voucherAllocationsData
                                    .map(item => item?.voucher?.id)
                                    .filter(Boolean),

                                invoiceItemIds: Array.isArray(invoiceItemAllocations)
                                    ? invoiceItemAllocations
                                        .map(item => item?.invoiceItem?.id)
                                        .filter(Boolean)
                                    : [],
                            };

                            handleGetListCodeSource(searchCodeSource, setFieldValue);
                            handleClose();
                        }}
                    >
                        <SaveIcon /> {t("save")}
                    </CommonButton>


                    <CommonButton className="btn-gray" onClick={handleClose} >
                        <BlockIcon /> {t('cancel')}
                    </CommonButton>
                </>
            }
        >
            <Formik
                initialValues={{
                    fromDate: null,
                    toDate: null,
                }}
                onSubmit={handleChangeFormSearch}
                enableReinitialize
            >
                {({ setFieldValue }) => {
                    return (
                        <Form autoComplete='off'>
                            <section className="cards-container">
                                <Grid container spacing={1}>
                                    <Grid container spacing={1} className="cards-body flex flex-end mt-2" >
                                        <Grid item xs={12} sm={6} md={10} >
                                            <GlobitsMultiDatePicker
                                                label="Từ ngày - đến ngày"
                                                name="fromDate"
                                                range
                                                rangeHover
                                                fromField="fromDate"
                                                toField="toDate"
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={2} className="flex">
                                            <Button className="btn-primary" type="submit">
                                                <Search />
                                                Tìm kiếm
                                            </Button>
                                        </Grid>
                                    </Grid>

                                    <Grid item xs={12}>
                                        <TableComponent
                                            className=""
                                            showOrdinalNumbers
                                            selectType="multi"
                                            handleChangeSelectedRows={(rows) => {
                                                const filtered = rows.filter(
                                                    row => !selectedVoucherIds.includes(row.id)
                                                );
                                                setSelectedRows(filtered);
                                            }}
                                            initStateRow={initSelectedRows}
                                            titleNodata={"Không có dữ liệu"}
                                            data={dataVoucherFee?.content || []}
                                            columns={[
                                                {
                                                    field: "voucherDate",
                                                    title: "Ngày lập hóa đơn",
                                                    align: "right",
                                                    render: (row) => (
                                                        <b>{getDateTime(row?.voucherDate)}</b>
                                                    ),
                                                },
                                                {
                                                    field: "code",
                                                    title: "Mã hóa đơn",
                                                },
                                                {
                                                    field: "moneyAfterDiscount",
                                                    title: "Tổng tiền",
                                                    align: "right",
                                                    render: (row) => (
                                                        <b>{formatMoney(row?.moneyAfterDiscount)}</b>
                                                    ),
                                                },
                                                {
                                                    field: "voucherInvoiceType",
                                                    title: "Loại",
                                                    algin: "center",
                                                    render: (row) =>
                                                        VOUCHER_INVOICE_TYPE?.find(
                                                            (el) => el?.value === row?.voucherInvoiceType
                                                        )?.name || "",
                                                },
                                                {
                                                    field: "department",
                                                    title: "Cơ sở",
                                                    align: "right",
                                                    render: (row) => (
                                                        <b>{row?.department?.name}</b>
                                                    ),
                                                },
                                                {
                                                    field: "accountant",
                                                    title: "Thu ngân",
                                                    align: "right",
                                                    render: (row) => (
                                                        <b>{row?.accountant?.staffName}</b>
                                                    ),
                                                },
                                                {
                                                    field: "note",
                                                    title: "Ghi chú",
                                                    align: "right",
                                                    render: (row) => (
                                                        <b>{row?.note}</b>
                                                    ),
                                                },
                                            ]}
                                            dataPagination={{
                                                pageIndex: searchVoucherFee?.pageIndex,
                                                pageSize: searchVoucherFee?.pageSize,
                                                totalElements: dataVoucherFee?.totalElements,
                                                totalPages: dataVoucherFee?.totalPages,
                                                setPageIndex: (pageIndex) =>
                                                    handleChangeFormSearch({ pageIndex }),
                                                setPageSize: (pageSize) =>
                                                    handleChangeFormSearch({ pageSize }),
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                            </section>
                        </Form>
                    );
                }}
            </Formik>
        </Popup>
    );
}

export default memo(observer(VoucherDepositDeductionPopup));
